import { Box, Text, Button } from '@chakra-ui/react'
import { Plus } from 'lucide-react'
import { BANK_ACCOUNT_TYPE_LABELS, BANK_ACCOUNT_TYPE_COLORS, type BankAccountType } from '../types'

interface BankAccountEmptyCardProps {
  accountType: BankAccountType
  onCreate: () => void
}

export function BankAccountEmptyCard({ accountType, onCreate }: BankAccountEmptyCardProps) {
  const typeLabel = BANK_ACCOUNT_TYPE_LABELS[accountType]
  const typeColor = BANK_ACCOUNT_TYPE_COLORS[accountType]

  const getCtaLabel = () => {
    switch (accountType) {
      case 'current':
        return 'Créer le compte courant'
      case 'alur_reserve':
        return 'Créer le compte fonds ALUR'
      case 'savings':
        return 'Créer un compte épargne'
    }
  }

  const getDescription = () => {
    switch (accountType) {
      case 'current':
        return 'Compte bancaire principal pour les opérations courantes de la copropriété'
      case 'alur_reserve':
        return 'Fonds de travaux obligatoire (loi ALUR) pour copropriétés >15 lots'
      case 'savings':
        return 'Compte d\'épargne pour la trésorerie de la copropriété'
    }
  }

  return (
    <Box
      p={6}
      bg="white"
      borderWidth="2px"
      borderColor={`${typeColor}.200`}
      borderStyle="dashed"
      borderRadius="md"
      position="relative"
      _hover={{ borderColor: `${typeColor}.300`, shadow: 'sm' }}
      transition="all 0.2s"
      minH="200px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      {/* Tag type sur la bordure */}
      <Box
        position="absolute"
        top="-12px"
        left="16px"
        bg="white"
        px={3}
        py={1}
        borderRadius="md"
        borderWidth="2px"
        borderColor={`${typeColor}.200`}
      >
        <Text fontSize="xs" fontWeight="semibold" color={`${typeColor}.700`}>
          {typeLabel}
        </Text>
      </Box>

      <Box color="gray.400" mb={3}>
        <Plus size={32} strokeWidth={1.5} />
      </Box>

      <Text fontSize="sm" color="gray.600" mb={4} maxW="250px">
        {getDescription()}
      </Text>

      <Button
        size="sm"
        colorPalette={typeColor}
        variant="outline"
        onClick={onCreate}
      >
        {getCtaLabel()}
      </Button>
    </Box>
  )
}
